import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=091283f4&scoped=true"
import script from "./Datatables.vue?vue&type=script&lang=js"
export * from "./Datatables.vue?vue&type=script&lang=js"
import style0 from "./Datatables.vue?vue&type=style&index=0&id=091283f4&prod&scoped=true&language=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091283f4",
  null
  
)

export default component.exports